import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { ResponsiveContext, Layer, Box, Button, Text, Anchor } from 'grommet';
import { FormClose, Share } from 'grommet-icons';

import { toggleAboutLayer } from '../actions/about';

class AboutComponent extends Component {
  render() {
    const {
      toggleLayer,
      toggleAboutLayer,
    } = this.props;

    if(!toggleLayer || toggleLayer !== 'about') {
      return null;
    }

    return (
      <ResponsiveContext.Consumer>
        {size => (
          <Layer
            responsive={false}
            full='vertical'

            position='left'
            onClickOutside={toggleAboutLayer}
            onEsc={toggleAboutLayer}
          >
            <Box
              fill='vertical'
              width={ size === 'small' ? '80vw' : '55vw' }
              pad={{
                top: 'large',
                horizontal: 'large'

              }}
              gap='medium'
              overflow='auto'
              flex
            >
              {/* cabeçalho */}
              <Box
                direction='row'
                justify='between'
                align='baseline'
                flex={{ shrink: 0 }}
              >
                <Text
                  size={ size === 'small' ? 'large' : 'xlarge' }
                >
                  Informações sobre as enquetes
                </Text>

                <Button
                  plain
                  title='Fechar'
                  icon={<FormClose />}
                  onClick={toggleAboutLayer}
                />
              </Box>


              {/* conteúdo */}
              <Box
                gap='large'
                flex={{ shrink: 0 }}
              >
                <Box>
                  <Text color='dark-2' size='small'>
                    As enquetes são criadas por clientes que utilizam o sistema <Anchor href='https://gerenciameumandato.com.br' target='_blank'>Gerencia Meu Mandato <Share color='brand' size='small' /></Anchor>.
                    A responsabilidade do teor das enquetes é inteira e exclusivamente dos autores.
                  </Text>
                </Box>

                <Box
                  gap='small'
                >
                  <Text color='brand' size='medium'>
                    Quais são os objetivos das enquetes?
                  </Text>

                  <Text color='dark-2' size='small'>
                    Por meio das enquetes disponibilizadas pode-se: Estimular o interesse da sociedade pelos temas em discussão e o conhecimento das propostas.
                    Dar ao cidadão a oportunidade de manifestar sua opinião e participar mais ativamente.
                  </Text>
                </Box>

                <Box
                  gap='small'
                >
                  <Text color='brand' size='medium'>
                    Quem pode visualizar meu voto?
                  </Text>

                  <Text color='dark-2' size='small'>
                    Apenas o autor da enquete pode visualizar esses resultados.
                  </Text>
                </Box>

                <Box
                  gap='small'
                >
                  <Text color='brand' size='medium'>
                    Como votar?
                  </Text>

                  <Text color='dark-2' size='small'>
                    O autor da enquete irá disponibilizar o link para votação.
                    Acesse o link a partir de um computador, tablet ou celular, escolha uma das opções e para finalizar clique em participar.
                  </Text>
                </Box>

                <Box
                  gap='small'
                >
                  <Text color='brand' size='medium'>
                    É necessário me cadastrar para votar numa enquete?
                  </Text>

                  <Text color='dark-2' size='small'>
                    Não é necessário efetuar qualquer tipo de cadastro para votar numa enquete.
                  </Text>
                </Box>

                <Box
                  gap='small'
                >
                  <Text color='brand' size='medium'>
                    Posso cancelar ou mudar o meu voto?
                  </Text>

                  <Text color='dark-2' size='small'>
                    Não é possível cancelar ou mudar o voto na enquete, uma vez que o resultado é publicado no momento de sua confirmação.
                    Cancelar ou alterar o voto afetaria frequentemente o resultado e comprometeria o objetivo da ferramenta.
                  </Text>
                </Box>
              </Box>
            </Box>
          </Layer>
        )}
      </ResponsiveContext.Consumer>
    )
  }
}

const mapStateToProps = ({ homeReducer: { layer } }) => ({
  toggleLayer: layer.toggleLayer,
});

const mapDispatchToProps = dispatch =>
  bindActionCreators({
    toggleAboutLayer,
  }, dispatch);

export const About = connect(mapStateToProps, mapDispatchToProps)(AboutComponent);
